export const GET_REMEDIATION_DATA_REQUEST = "GET_REMEDIATION_DATA_REQUEST";
export const GET_REMEDIATION_DATA_SUCCESS = "GET_REMEDIATION_DATA_SUCCESS";
export const GET_REMEDIATION_DATA_FAIL = "GET_REMEDIATION_DATA_FAIL";
export const GET_REMEDIATION_DATA_RESET = "GET_REMEDIATION_DATA_RESET";

export const UPDATE_REMEDIATION_DATA = "UPDATE_REPORT_DATA";

export const GET_TEST_LIST_REQUEST = "GET_TEST_LIST_REQUEST";
export const GET_TEST_LIST_SUCCESS = "GET_TEST_LIST_SUCCESS";
export const GET_TEST_LIST_FAIL = "GET_TEST_LIST_FAIL";
export const GET_TEST_LIST_RESET = "GET_TEST_LIST_RESET";

export const ADD_REMEDIATION_ROW_REQUEST = "ADD_REMEDIATION_ROW_REQUEST";
export const ADD_REMEDIATION_ROW_SUCCESS = "ADD_REMEDIATION_ROW_SUCCESS";
export const ADD_REMEDIATION_ROW_FAIL = "ADD_REMEDIATION_ROW_FAIL";

export const UPDATE_HEADER_INFO_REQUEST = "UPDATE_HEADER_INFO_REQUEST";
export const UPDATE_HEADER_INFO_SUCCESS = "UPDATE_HEADER_INFO_SUCCESS";
export const UPDATE_HEADER_INFO_FAIL = "UPDATE_HEADER_INFO_FAIL";

export const ROW_SELECTION_REQUEST = "ROW_SELECTION_REQUEST";
export const ROW_SELECTION_SUCCESS = "ROW_SELECTION_SUCCESS";
export const ROW_SELECTION_FAIL = "ROW_SELECTION_FAIL";

export const SAVE_REMEDIATION_DATA_REQUEST = "SAVE_REMEDIATION_DATA_REQUEST";
export const SAVE_REMEDIATION_DATA_SUCCESS = "SAVE_REMEDIATION_DATA_SUCCESS";
export const SAVE_REMEDIATION_DATA_FAIL = "SAVE_REMEDIATION_DATA_FAIL";

export const REFRESH_REMEDIATION_DATA_REQUEST =
  "REFRESH_REMEDIATION_DATA_REQUEST";
export const REFRESH_REMEDIATION_DATA_SUCCESS =
  "REFRESH_REMEDIATION_DATA_SUCCESS";
export const REFRESH_REMEDIATION_DATA_FAIL = "REFRESH_REMEDIATION_DATA_FAIL";

export const PUBLISH_REMEDIATION_DATA_REQUEST =
  "PUBLISH_REMEDIATION_DATA_REQUEST";
export const PUBLISH_REMEDIATION_DATA_SUCCESS =
  "PUBLISH_REMEDIATION_DATA_SUCCESS";
export const PUBLISH_REMEDIATION_DATA_FAIL = "PUBLISH_REMEDIATION_DATA_FAIL";

export const GET_REMEDIATION_REPORT_RESET = "GET_REMEDIATION_REPORT_RESET";
